module.exports = __webpack_public_path__ + "static/assets/media/nubi_web_low.03bf9f93.mp4";